const binding = { modules: {}, dataActions: {} };

    (binding.modules['gh-site-gate'] = {
        c: () => require('partner/modules/gh-site-gate/gh-site-gate.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gh-site-gate',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gh-site-gate'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|gh-site-gate|gh-site-gate'] = {
                c: () => require('partner/modules/gh-site-gate/gh-site-gate.view.tsx'),
                cn: '__local__-__local__-gh-site-gate'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };